export default "__VITE_ASSET__BuTJc_Qm__"